import { gql as gqlBase } from "@edreamsodigeo/frontend-api-client-base";
import { Gql } from "./types";

export const gql: Gql = gqlBase;
